import { useEffect } from "react";
import { toast } from "@/hooks/use-toast";

export const useAuthErrorNotification = () => {
  useEffect(() => {
    const handleAuthError = (event: Event) => {
      const customEvent = event as CustomEvent<{
        error: string;
        endpoint: string;
      }>;
      const { error, endpoint } = customEvent.detail;

      // Show a toast notification
      toast({
        title: "Authentication Error",
        description: `Your session has expired. Changes may not be saved. You'll be redirected to sign in.`,
        variant: "destructive",
        duration: 5000,
      });

      console.log(`Auth error on ${endpoint}: ${error}`);
    };

    window.addEventListener("authError", handleAuthError);

    return () => {
      window.removeEventListener("authError", handleAuthError);
    };
  }, []);
};
